/*
<COPYRIGHT>

    Copyright © 2016-2026, Canyon GBS Inc. All rights reserved.

    Notice:

    - This software is closed source and the source code is a trade secret.
    - You may not alter, remove, or obscure any licensing, copyright, or other notices
      of the licensor in the software.
    - Canyon GBS Inc. respects the intellectual property rights of others and expects the
      same in return. Canyon GBS® is a registered trademarks of Canyon GBS Inc., and we are
      committed to enforcing and protecting our trademarks vigorously.

    For more information or inquiries please visit our website at
    https://www.canyongbs.com or contact us via email at legal@canyongbs.com.

</COPYRIGHT>
*/
(function () {
    // Get the embed element
    const embedElement = document.querySelector('marketing-list-subscription-embed');
    if (!embedElement) throw new Error('Embed not found');

    // Get the assets URL from the element
    const assetsUrl = embedElement.getAttribute('url');
    if (!assetsUrl) throw new Error('Assets URL not found');

    // Fetch the latest assets URLs
    fetch(assetsUrl)
        .then((response) => response.json())
        .then((assets) => {
            if (!assets || !assets.asset_url || !assets.submission_url || !assets.js || !assets.config_url) {
                throw Error('Assets are missing or incomplete.');
            }

            embedElement.setAttribute('submission-url', assets.submission_url);
            embedElement.setAttribute('config-url', assets.config_url);

            // Set up the global variable for Vite's dynamic imports using the asset endpoint
            window.__VITE_MARKETING_LIST_SUBSCRIPTION_ASSET_URL__ = assets.asset_url;

            const scriptElement = document.createElement('script');
            scriptElement.src = assets.js;
            scriptElement.type = 'module';
            document.body.appendChild(scriptElement);
        })
        .catch((error) => {
            console.error('Failed to load widget assets:', error);
        });
})();
